import { mapState, mapMutations } from "vuex"

export default {
  data: function () {
    return {
      config: [
        {
          i18n: "layout.navigation.dashMenu00",
          icon: { fas: true, "fa-comment-dots": true },
          link: {
            path: "/band/dashboard/",
            query: { banddashtab: "answered" },
          },
        },
        {
          i18n: "layout.navigation.dashMenu01",
          icon: { fas: true, "fa-clock": true },
          link: {
            path: "/band/dashboard/",
            query: { banddashtab: "pending" },
          },
        },
        {
          i18n: "layout.navigation.dashMenu02",
          icon: { fas: true, "fa-calendar-times": true },
          link: {
            path: "/band/dashboard/",
            query: { banddashtab: "expired" },
          },
        },
      ],
    }
  },
  computed: {
    ...mapState({
      submissions_arr: (state) => state.user.submissions,
    }),
  },
  methods: {
    handleClick: function (index) {
      console.log("***HANDLE")
      this.change_meta_filter(index)
      if (!this.$route.path.includes("/band/dashboard/"))
        this.$router.push({ path: "/band/dashboard/" })
      this.$emit("close")
    },
    ...mapMutations({
      change_meta_filter: "band_dashboard/CHANGE_META_FILTER",
    }),
  },
}
